import { render, staticRenderFns } from "./EmployeeOverviewReleation.vue?vue&type=template&id=5f5c397c&"
import script from "./EmployeeOverviewReleation.vue?vue&type=script&lang=js&"
export * from "./EmployeeOverviewReleation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports